const results = [
  { stat: '+37%', label: 'More Booked Jobs', desc: 'Without adding a single staff member', color: '#2563EB' },
  { stat: '10x', label: 'Faster Response', desc: 'From hours to seconds', color: '#06B6D4' },
  { stat: '100%', label: 'Lead Coverage', desc: 'Every opportunity captured', color: '#22C55E' },
  { stat: '30d', label: 'Time to ROI', desc: 'Measurable returns in the first month', color: '#F97316' },
];

const outcomes = [
  'Increase booked jobs without increasing staff',
  'Improve response time from hours to seconds',
  'Capture previously lost revenue',
  'Streamline operations and dispatch flow',
];

export default function ResultsSection() {
  return (
    <section className="bg-[#F8FAFC] py-28 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-[#22C55E] text-xs font-semibold tracking-[0.2em] uppercase mb-5 font-inter">Real Outcomes</p>
          <h2 className="text-5xl md:text-6xl font-black text-[#0F172A] leading-[1.05] tracking-tight font-poppins">
            Built for Real<br />Business Outcomes
          </h2>
        </div>

        {/* Stats — Apple-style large number cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          {results.map((r, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl p-8 border border-[#E2E8F0]/80 hover:border-transparent transition-all duration-500 relative overflow-hidden cursor-default"
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"
                style={{ background: `linear-gradient(135deg, ${r.color}08, ${r.color}04)` }}
              ></div>
              <div className="relative z-10">
                <div
                  className="text-5xl md:text-6xl font-black mb-3 font-poppins leading-none"
                  style={{ color: r.color }}
                >
                  {r.stat}
                </div>
                <div className="text-[#0F172A] font-semibold text-base mb-1.5 font-poppins">{r.label}</div>
                <div className="text-[#334155]/40 text-sm font-inter">{r.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Outcomes + Visual — two-column */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Outcomes list */}
          <div className="bg-white rounded-2xl p-8 md:p-10 border border-[#E2E8F0]/80">
            <h3 className="text-[#0F172A] font-bold text-xl mb-8 font-poppins">What You Get</h3>
            <div className="space-y-5">
              {outcomes.map((item, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#ECFDF5] flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-[#22C55E] text-xs"></i>
                  </div>
                  <span className="text-[#334155] text-base font-inter">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Visual card */}
          <div className="relative bg-[#0F172A] rounded-2xl overflow-hidden min-h-[320px]">
            <img
              src="https://public.readdy.ai/ai/img_res/1fba853fd4510f59d357f0dcf63e058a.jpg"
              alt="Home service professional"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/80 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="flex -space-x-1.5">
                  {[1,2,3].map((i) => (
                    <div key={i} className="w-7 h-7 rounded-full border-2 border-[#0F172A] bg-[#2563EB]/30 flex items-center justify-center">
                      <i className="ri-user-line text-white/60 text-xs"></i>
                    </div>
                  ))}
                </div>
                <span className="text-white/50 text-xs font-inter">200+ businesses scaling with PureHomeScale</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
